import { BaseRemoteService } from "@ofqual/portal-core/core/dataAccess";
import { Opts } from "@ofqual/portal-core/core/types";
import { fromApiModel, Scope } from "@ofqual/portal-organisations-scope/dist/module/domain/Scope";

export class OrgScopesService extends BaseRemoteService {
  public async get(id: string, opts: Opts): Promise<Scope[]> {
    try {
    const url = `${this.apiRoot}/api/scope/${id}?includeFuture=true`;
    const scopes = await super.getRequest<Scope[]>(url, opts);
    return scopes.map(scope => fromApiModel(scope));
    } catch (err: any) {
      if (err && err.status === 404) {
        return [];
      }
      throw err;
    }
  }
}
